var UseLoadingStates;
(function (UseLoadingStates) {
    UseLoadingStates["LOADED"] = "loaded";
    UseLoadingStates["LOADING"] = "loading";
    UseLoadingStates["ERROR"] = "error";
})(UseLoadingStates || (UseLoadingStates = {}));

export { UseLoadingStates };
